import { render, staticRenderFns } from "./SubscriptionTable.vue?vue&type=template&id=159964ab&scoped=true"
import script from "./SubscriptionTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionTable.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTable.vue?vue&type=style&index=0&id=159964ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159964ab",
  null
  
)

export default component.exports